import script from "./EditAssignmentQuotaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAssignmentQuotaModal.vue?vue&type=script&setup=true&lang=js"

import "./EditAssignmentQuotaModal.vue?vue&type=style&index=0&id=22bbe2c0&scoped=true&lang=css"
script.__scopeId = "data-v-22bbe2c0"

export default script